import {
  ThemeOptions,
  WBDesignSystemProvider,
  WBSnackbarProvider,
} from '@admiin-com/ds-web';
import { darkTheme, theme } from '@admiin-com/ds-design-token';
import { deepmerge } from 'deepmerge-ts';
import { LinkBehavior } from './components';
import { NavRoutes } from './navigation/NavRoutes';
import * as Sentry from '@sentry/react';
import './i18n';
import Gleap from 'gleap';
import { useFeatureFlags } from './hooks/useFeatureFlags/useFeatureFlags';
import { ModalProvider } from './features/components/ModalManager/ModalContext';
import { ModalManager } from './features/components/ModalManager/ModalManager';
import { useEffect } from 'react';
import { useMixpanel } from './hooks/useMixpanel/useMixpanel';
import { ErrorBoundary } from './components';

const { VITE_ENV, VITE_GLEAP_API_TOKEN, VITE_SENTRY_DSN } = import.meta.env;

if (VITE_ENV === 'prod') {
  Gleap.initialize(VITE_GLEAP_API_TOKEN);
  Gleap.setEnvironment(VITE_ENV === 'prod' ? 'prod' : 'dev');
}

const commonTheme = {
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
    },
  },
};

// TODO: (EDIT: I think fixed?) throwing ts error although behaviour working for component: LinkBehaviour for MuiLink
const appTheme: ThemeOptions = deepmerge(theme, commonTheme);
const appDarkTheme: ThemeOptions = deepmerge(darkTheme, commonTheme);

Sentry.init({
  dsn: VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
  enabled: !!VITE_SENTRY_DSN && VITE_ENV === 'prod',
  environment: VITE_ENV,
  allowUrls: [/app\.admiin\.com/],
});

export function App() {
  const { track } = useMixpanel();
  const { featureFlags } = useFeatureFlags();

  useEffect(() => {
    track('app_loaded');
  }, [track]);

  const isNewLayoutEnabled = featureFlags?.newLayout;

  return (
    <WBDesignSystemProvider
      theme={appTheme}
      darkTheme={appDarkTheme}
      isNewThemeEnabled={isNewLayoutEnabled}
    >
      <WBSnackbarProvider>
        <ModalProvider>
          <ErrorBoundary>
            <NavRoutes />
          </ErrorBoundary>
          <ModalManager />
        </ModalProvider>
      </WBSnackbarProvider>
    </WBDesignSystemProvider>
  );
}

export default App;
